// Full-screen animated "Payment successful" overlay. Vanilla (no React), so it
// can be fired straight from the payment util. Draws an animated check + pulse,
// then calls onDone() (e.g. redirect to the dashboard).

let stylesInjected = false;
function injectStyles() {
  if (stylesInjected) return;
  stylesInjected = true;
  const s = document.createElement("style");
  s.textContent = `
    @keyframes pp-fade { from { opacity: 0 } to { opacity: 1 } }
    @keyframes pp-pop {
      0% { transform: scale(.85); opacity: 0 }
      60% { transform: scale(1.03) }
      100% { transform: scale(1); opacity: 1 }
    }
    @keyframes pp-ring  { to { stroke-dashoffset: 0 } }
    @keyframes pp-check { to { stroke-dashoffset: 0 } }
    @keyframes pp-pulse { 0% { transform: scale(1); opacity: .45 } 100% { transform: scale(1.9); opacity: 0 } }
  `;
  document.head.appendChild(s);
}

/**
 * @param {{ title?, subtitle?, duration?, onDone? }} opts
 */
export function showPaymentSuccess(opts = {}) {
  const {
    title = "Payment successful",
    subtitle = "Setting up your community…",
    duration = 2300,
    onDone,
  } = opts;

  injectStyles();

  const overlay = document.createElement("div");
  Object.assign(overlay.style, {
    position: "fixed",
    inset: "0",
    zIndex: "2147483000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(15,15,20,0.55)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    animation: "pp-fade .25s ease both",
    padding: "16px",
  });

  const card = document.createElement("div");
  Object.assign(card.style, {
    background: "#ffffff",
    borderRadius: "20px",
    padding: "36px 40px",
    textAlign: "center",
    maxWidth: "340px",
    width: "88%",
    boxShadow: "0 24px 60px rgba(0,0,0,.30)",
    animation: "pp-pop .45s cubic-bezier(.2,.8,.3,1.2) both",
    fontFamily: "inherit",
  });

  card.innerHTML = `
    <div style="position:relative;width:96px;height:96px;margin:0 auto 18px">
      <span style="position:absolute;inset:0;border-radius:50%;background:#22c55e;opacity:.45;animation:pp-pulse 1s ease-out .45s both"></span>
      <svg width="96" height="96" viewBox="0 0 96 96" style="position:relative;display:block">
        <circle cx="48" cy="48" r="44" fill="none" stroke="#22c55e" stroke-width="5"
          stroke-linecap="round" stroke-dasharray="276" stroke-dashoffset="276"
          transform="rotate(-90 48 48)" style="animation:pp-ring .6s ease forwards" />
        <path d="M30 49 L43 62 L67 36" fill="none" stroke="#22c55e" stroke-width="6"
          stroke-linecap="round" stroke-linejoin="round"
          stroke-dasharray="70" stroke-dashoffset="70" style="animation:pp-check .4s .55s ease forwards" />
      </svg>
    </div>
    <div style="font-size:20px;font-weight:700;color:#111827">${title}</div>
    <div style="margin-top:6px;font-size:14px;color:#6b7280">${subtitle}</div>
  `;

  overlay.appendChild(card);
  document.body.appendChild(overlay);

  setTimeout(() => {
    overlay.style.transition = "opacity .3s ease";
    overlay.style.opacity = "0";
    setTimeout(() => {
      overlay.remove();
      if (onDone) onDone();
    }, 300);
  }, duration);
}

export default showPaymentSuccess;
